import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

export const PpnToggle = ({ enabled, percent, onChange, testId = "ppn" }) => (
  <div className="flex flex-wrap items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3">
    <Switch checked={!!enabled} onCheckedChange={(v) => onChange({ ppn_enabled: v })} data-testid={`${testId}-toggle`} />
    <span className="text-sm font-semibold">Tambahkan PPN</span>
    {enabled && (
      <div className="flex items-center gap-1">
        <Input type="number" className="h-8 w-20 bg-white font-num" value={percent} onChange={(e) => onChange({ ppn_percent: e.target.value })} data-testid={`${testId}-percent-input`} />
        <span className="text-sm text-slate-500">%</span>
      </div>
    )}
    <span className="text-xs text-slate-500">{enabled ? "Total penawaran sudah termasuk pajak" : "Harga belum termasuk PPN"}</span>
  </div>
);
